'use strict';

angular.module('atex.dam').factory('DamDynamicQueriesService', [ '$rootScope', function($rootScope) {
  
  var dynQueriesArray = [];
  
  $rootScope.$on("dam:logout", function() {
    dynQueriesArray.length = 0; // Put length to 0 don't reset reference
  });
  
  return {
    addUpdateQuery : function(damid, solrQuery) {
      var currentQuery = _.find(dynQueriesArray, function(query) {
        return damid === query.damid;
      });
      if (currentQuery) {
        currentQuery.solrQuery = solrQuery;
      } else {
        dynQueriesArray.push({
          'damid' : damid,
          'solrQuery' : solrQuery
        });
      }
    },
    
    removeQuery : function(damid) {
      angular.forEach(dynQueriesArray, function(query, key) {
        if (query.damid === damid) {
          dynQueriesArray.splice(key, 1);
        }
      });
    },
    
    getDynQueries : function() {
      return dynQueriesArray;
    },
    
    clearQueries : function() {
      dynQueriesArray.length = 0;
    }
  };
} ]);
